export default "__VITE_ASSET__$qpTdtMx__"